class ProductInfo extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.querySelector('product-form');
    const productTitle = this.querySelector('.product__title')?.textContent.trim().toLowerCase();
    this.productTitle = productTitle.charAt(0).toUpperCase() + productTitle.slice(1);
    this.productPrice = this.querySelector('.price__item')?.textContent.trim();
    this.quantityInput = this.querySelector('quantity-input');
    this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
    this.reserveButton = this.querySelector('reserve-product button');
  }

  connectedCallback() {
    this.quantityInputElement?.addEventListener('change', () => this.handleQuantityInput());
    this.addToRecentlyViewed();
  }

  /**
   * addToRecentlyViewed
   * @description Function to add a product to the recently viewed list
   */
  addToRecentlyViewed() {
    // Check if the window properties are available, if not check again in 100ms
    const productUrl = window.current.product.url;
    const maxRecentlyViewedProducts = window.maxRecentlyViewedProducts;

    var recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
    if (!recentlyViewed) return;

    // Check if the product is already in the list, remove it if found
    var index = recentlyViewed.indexOf(productUrl);
    if (index !== -1) {
      recentlyViewed.splice(index, 1);
    }

    // Add the product to the beginning of the list
    recentlyViewed.unshift(productUrl);

    // Limit the list to a certain number of products
    if (recentlyViewed.length > maxRecentlyViewedProducts) {
      recentlyViewed = recentlyViewed.slice(0, maxRecentlyViewedProducts);
    }

    // Store the updated list back to session storage
    localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewed));
  }
}

class ReserveProduct extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', () => this.addToReserve());
  }

  addToReserve() {
    const reservedProducts = JSON.parse(sessionStorage.getItem('reservedProducts') || '[]');
    const productInfo = this.closest('product-info');
    const quantityInput = productInfo?.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    const {
      productId,
      productSku,
      productUrl,
      productTitle,
      productPrice,
      productImage,
      stepOneUrl,
    } = this.dataset;

    const product = {
      id: productId,
      sku: productSku,
      url: productUrl,
      title: productTitle,
      price: productPrice,
      image: productImage,
      quantity: quantity,
    };

    // If the product is not already in the reserved products list
    if (!reservedProducts.some((p) => p.id === product.id)) {
      // Add the product to the reserved products list
      reservedProducts.push(product);

      // Store the updated list back to session storage
      sessionStorage.setItem('reservedProducts', JSON.stringify(reservedProducts));
    }

    window.location = stepOneUrl;
  }
}

if (!customElements.get('product-info')) {
  customElements.define('product-info', ProductInfo);
}

if (!customElements.get('reserve-product')) {
  customElements.define('reserve-product', ReserveProduct);
}
